import { render, staticRenderFns } from "./LoyaltyCertUpdateComponent.vue?vue&type=template&id=6a630f97&scoped=true"
import script from "./LoyaltyCertUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyCertUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a630f97",
  null
  
)

export default component.exports